import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Tooltip.module.scss';
import { TooltipPositions } from '../../../modules/userApps/AppSettings/constants';
export interface ITooltip extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
  showTooltip: boolean;
  position?: TooltipPositions;
}

const Tooltip: FC<ITooltip> = (props) => {
  const { className, children, showTooltip = false, position = TooltipPositions.RIGHT } = props;
  const rootClassName = classNames(styles.root, className, {
    [styles.right]: position === TooltipPositions.RIGHT,
    [styles.left]: position === TooltipPositions.LEFT,
  });

  if (!showTooltip) return null;

  return <div className={rootClassName}>{children}</div>;
};

export default Tooltip;
